import React, { useState, useEffect } from 'react';
import { useProducts } from '../context/ProductContext';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ProductForm = () => {
    const { addProduct, updateProduct, products } = useProducts();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const editId = searchParams.get('edit');

    const [formData, setFormData] = useState({
        productName: '',
        logoUrl: '',
        price: '',
        sizes: []
    });

    useEffect(() => {
        if (editId) {
            const productToEdit = products.find(p => p.id === Number(editId));
            if (productToEdit) {
                setFormData(productToEdit);
            }
        }
    }, [editId, products]);

    const AVAILABLE_SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const toggleSize = (size) => {
        setFormData(prev => ({
            ...prev,
            sizes: prev.sizes.includes(size)
                ? prev.sizes.filter(s => s !== size)
                : [...prev.sizes, size]
        }));
    };

    const toggleSelectAll = () => {
        if (formData.sizes.length === AVAILABLE_SIZES.length) {
            setFormData(prev => ({ ...prev, sizes: [] }));
        } else {
            setFormData(prev => ({ ...prev, sizes: [...AVAILABLE_SIZES] }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (editId) {
            updateProduct({
                ...formData,
                id: Number(editId)
            });
        } else {
            const newProduct = {
                ...formData,
                id: Date.now()
            };
            addProduct(newProduct);
        }

        setFormData({ productName: '', logoUrl: '', price: '', sizes: [] });
        navigate('/products'); // Redirect to list
    };

    return (
        <div className="single-column-page">
            <div className="form-container-card">
                <div className="form-header-simple">
                    <h2>{editId ? 'Edit Product' : 'Add New Product'}</h2>
                    <button onClick={() => navigate('/products')} className="text-btn">Cancel</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Product Name</label>
                        <input
                            type="text"
                            name="productName"
                            value={formData.productName}
                            onChange={handleInputChange}
                            placeholder="e.g. Classic White Tee"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Logo / Image URL</label>
                        <input
                            type="url"
                            name="logoUrl"
                            value={formData.logoUrl}
                            onChange={handleInputChange}
                            placeholder="https://example.com/image.png"
                        />
                    </div>

                    <div className="form-group">
                        <label>Price (₹)</label>
                        <input
                            type="number"
                            name="price"
                            value={formData.price}
                            onChange={handleInputChange}
                            placeholder="1999"
                            min="0"
                            step="1"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            <label style={{ margin: 0 }}>Available Sizes</label>
                            <button
                                type="button"
                                onClick={toggleSelectAll}
                                className="text-btn"
                                style={{ fontSize: '0.8rem', color: '#38bdf8' }}
                            >
                                {formData.sizes.length === AVAILABLE_SIZES.length ? 'Deselect All' : 'Select All'}
                            </button>
                        </div>
                        <div className="sizes-grid">
                            {AVAILABLE_SIZES.map(size => (
                                <button
                                    type="button"
                                    key={size}
                                    className={`size-btn ${formData.sizes.includes(size) ? 'active' : ''}`}
                                    onClick={() => toggleSize(size)}
                                >
                                    {size}
                                </button>
                            ))}
                        </div>
                    </div>

                    <button type="submit" className="submit-btn">
                        {editId ? 'Update Product' : 'Add & View Inventory'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ProductForm;
